import React from "react";
import { Button, MessageModalLayout, Modal, Page, Tabs, Text, WixDesignSystemProvider } from "@wix/design-system";
import { withProviders } from "../../withProviders";
import "@wix/design-system/styles.global.css";
import "../index.css";
import InventorySettings from "../../../components/features/settings/InventorySettings";
import OrderSettings from "../../../components/features/settings/OrderSettings";
import CurrencySettings from "../../../components/features/settings/CurrencySettings";
import Site from "../../../models/site";
import { showToast } from "@wix/dashboard-sdk";
import FaireContext from "../../../contexts/faire-context";
import TrialExpiryAlert from "../../../components/trial-expiry-alert";

const items = [
  { id: 0, title: "Inventory Settings" },
  { id: 1, title: "Order Settings" },
  { id: 2, title: "Currency Settings" },
];

function TabPanel({ children, value, index }: { children: React.ReactElement; value: number; index: number }) {
  switch (value) {
    case index:
      return <div>{children}</div>;
    default:
      return null;
  }
}

const Index = () => {
  const [tabValue, setTabValue] = React.useState(0);

  function handleTabChange(data: number) {
    setTabValue(data);
  }

  /*
  |--------------------------------------------------------------------------
  | Handle disconnect Faire
  |--------------------------------------------------------------------------
  |
  */

  const { isFaireConnected, setIsFaireConnected } = React.useContext(FaireContext);
  const [disconnectingFaireAccount, setDisconnectingFaireAccount] = React.useState(false);
  const [showConfirmationToDisconnectFaire, setShowConfirmationToDisconnectFaire] = React.useState(false);
  const handleDisconnectFaire = () => {
    setShowConfirmationToDisconnectFaire(true);
  };
  const handleCancelDisconnectToFaire = () => {
    if (disconnectingFaireAccount) return;
    setShowConfirmationToDisconnectFaire(false);
  };
  const handleConfirmDisconnectToFaire = () => {
    disconnectFaire();
  };
  const disconnectFaire = () => {
    if (disconnectingFaireAccount) return;
    setDisconnectingFaireAccount(true);

    Site.disconnectFaireAccount()
      .then((response) => {
        showToast({
          type: "success",
          message: response.message,
        });
        setIsFaireConnected(false);
      })
      .catch((error) => {
        showToast({
          type: "error",
          message: error.message,
        });
      })
      .finally(() => {
        setDisconnectingFaireAccount(false);
        setShowConfirmationToDisconnectFaire(false);
      });
  };

  return (
    <WixDesignSystemProvider>
      <Page height="95vh">
        {isFaireConnected && (
          <Page.Header
            title="Faire Integration Settings"
            actionsBar={
              isFaireConnected ? (
                <Button skin="destructive" onClick={handleDisconnectFaire}>
                  Disconnect Faire Store
                </Button>
              ) : undefined
            }
          />
        )}
        <Page.Content>
          <Modal
            isOpen={showConfirmationToDisconnectFaire}
            onRequestClose={handleCancelDisconnectToFaire}
            shouldCloseOnOverlayClick={!disconnectingFaireAccount}
          >
            <MessageModalLayout
              primaryButtonProps={{ disabled: disconnectingFaireAccount }}
              secondaryButtonProps={{ disabled: disconnectingFaireAccount }}
              theme={"destructive"}
              onCloseButtonClick={disconnectingFaireAccount ? undefined : handleCancelDisconnectToFaire}
              primaryButtonText="Yes"
              primaryButtonOnClick={handleConfirmDisconnectToFaire}
              secondaryButtonText="Cancel"
              secondaryButtonOnClick={handleCancelDisconnectToFaire}
              title="Disconnect Faire"
              content={<Text>Are you sure your want to disconnect your Faire account?</Text>}
            />
          </Modal>
          {isFaireConnected && (
            <>
              <TrialExpiryAlert />
              <Tabs
                className="settings_tabs"
                activeId={tabValue}
                items={items}
                onClick={(item: any) => handleTabChange(item.id)}
              />
              <TabPanel value={tabValue} index={0}>
                <InventorySettings />
              </TabPanel>
              <TabPanel value={tabValue} index={1}>
                <OrderSettings />
              </TabPanel>
              <TabPanel value={tabValue} index={2}>
                <CurrencySettings />
              </TabPanel>
            </>
          )}
        </Page.Content>
      </Page>
    </WixDesignSystemProvider>
  );
};

export default withProviders(Index);
